import React from "react";
import "./collections.css";

function Collections() {
  const items = [
    {  img: "/images/1.jpeg" },  
    {  img: "/images/5.jpeg" },
    {  img: "/images/3.jpeg" },
    {  img: "/images/4.jpeg" },
  ];

  // name: "Jewelry",

  return (
    <section className="collections" id="collections">
      <h2>FEATURED COLLECTIONS</h2>
      <div className="collection-grid">
        {items.map((item, i) => (
          <div key={i} className="card">
            <img src={item.img} alt={item.name} />
            <h3>{item.name}</h3>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Collections;
